<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-card-title
        class="body-1"
        style="background-color: #000; color: white;"
      >
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <booking-form
          @valid="saveButtonDisabled = false"
          @invalid="saveButtonDisabled = true"
        />
      </v-card-text>
      <v-card-actions class="px-9">
        <v-spacer></v-spacer>
        <v-btn color="accent" text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn
          color="secondary"
          :disabled="saveButtonDisabled"
          @click="saveBooking()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import Booking from '@/models/booking'
import BookingForm from './BookingForm.vue'

export default {
  name: 'EditBookingDialog',
  components: {
    BookingForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      saveButtonDisabled: true
    }
  },
  computed: {
    ...mapGetters('app', ['error']),
    ...mapGetters('booking', ['selectedBooking']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
          this.$store.commit(
            'booking/setSelectedBooking',
            new Booking().getObject()
          )
          this.$store.commit('booking/setSelectedBookingProfile', undefined)
        }
      }
    }
  },
  methods: {
    async saveBooking() {
      if (this.selectedBooking.ID > 0) {
        this.$store
          .dispatch('booking/putBooking', { this: this })
          .then(success => {
            if (success) {
              this.show = false
            }
          })
      } else {
        this.$store
          .dispatch('booking/postBooking', { this: this })
          .then(success => {
            if (success) {
              this.show = false
            }
          })
      }
    }
  }
}
</script>
